<template>
  <div class="website-external-wrapper">
    <AppHeader
      :hide-menu="true"
      :key="'app-header'+$route.fullPath"
    ></AppHeader>
    <div
      class="website-container"
    >
      <WebContainer
        :site-content="siteContent"
      ></WebContainer>
      
      <div class="surveys-wrapper delay-entry delay-more delay-like-crazy" v-if="false">
        <router-link
          :to="`/s/${key}/0`"
          v-for="(survey, key) in surveyFridge"
          v-if="survey.ogImage"
          :key="key"
          class="survey-item"
        >
          <div class="item-wrapper" v-if="surveyFridge">
            <div class="image"
              :style="{backgroundImage: `url(${survey.ogImage.fields.file.url})`}"
              v-if="survey.ogImage && survey.ogImage.fields && survey.ogImage.fields.file"
            ></div>
            <div class="text">
              <h2>{{survey.ogTitle}}</h2>
              <p>{{survey.ogDescription}}</p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="powered-by-wrapper">
        <a href="https://www.contentful.com/" rel="nofollow" target="_blank" class="powered-item"><img src="https://images.ctfassets.net/fo9twyrwpveg/44baP9Gtm8qE2Umm8CQwQk/c43325463d1cb5db2ef97fca0788ea55/PoweredByContentful_LightBackground.svg" style="max-width:100px;width:100%;" alt="Powered by Contentful" /></a>
        <div class="small-text">
          This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and
              <a href="https://policies.google.com/terms">Terms of Service</a> apply.          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from 'Core/src/api/index'
import Vue from 'vue'

export default {
  name: 'Home',

  transition: 'page',

  props: [ 'bgImage' ],

  components: {
    AppHeader: () => import('Components/web/AppHeader'),
    WebContainer: () => import('LocalComponents/WebContainer'),
    Icons: () => import('Components/base/Icons'),
  },

  data () {
    return {
      refs: [],
      content: {}
    }
  },

  computed: {
    siteContent () {
      if (this.$store.state.surveyRefs && this.$store.state.surveyRefs.fields)
      return this.$store.state.surveyRefs.fields.webContent || {}
    },
    shortcode () {
      return this.$route.params.shortcode
    },
    surveyFridge () {
      return this.$store.state.surveyFridge
    },
  },

  mounted () {
    this.$store.dispatch('LOAD_SURVEY_REFS')
      .then(async r => {
        var keys = Object.keys(r.fields.refs)
        await keys.forEach(key => {
          this.$store.dispatch('LOAD_NEW_SURVEY', { surveyId: r.fields.refs[key] })
        })
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 999)
        setTimeout(() => {
          if (this.shortcode && r.fields.refs[this.shortcode]) {
            this.$router.push(`/s/${r.fields.refs[this.shortcode]}/0`)
          }
        }, 1000)
      })
  },

  methods: {

  },

  metaInfo () {
    return {
      title: 'Tests y consulta de opinión | Sensata UX Research',
      meta: [
        { 'property': 'og:url', 'content': 'https://sens.la', 'vmid': 'og:url'},
        { 'property': 'og:image:width', 'content': '512', 'vmid': 'og:image:width'},
        { 'property': 'og:image:height', 'content': '512', 'vmid': 'og:image:height'},
        { 'property': 'og:image:type', 'content': 'image/jpeg', 'vmid': 'og:image:type'},
        { 'property': 'og:type', 'content': 'website', 'vmid': 'og:type'},
        { 'property': 'og:title', 'content': 'Tests y consulta de opinión | Sensata UX', 'vmid': 'og:title'},
        { 'property': 'og:description', 'content': '¡Pruebe sus conocimientos y compare sus opiniones con las de los demás!', 'vmid': 'og:description'},
        { 'property': 'twitter:description', 'content': '¡Pruebe sus conocimientos y compare sus opiniones con las de los demás!', 'vmid': 'twitter:description'},
        { 'property': 'og:image', 'content': 'https://sens.la/img/icons/android-chrome-512x512.png', 'vmid': 'og:image'},
        { 'property': 'twitter:image', 'content': 'https://sens.la/img/icons/android-chrome-512x512.png', 'vmid': 'twitter:image'},
      ]

    }
  }
}
</script>

<style scoped lang="scss">
.powered-by-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  background-color: $gray-light;
  flex-wrap: wrap;
}
.small-text {
  margin-top: 1em;
  font-size: 12px;
  text-align: left;
  @include breakpoint($tablet) {
    text-align: right;
    max-width: 300px;
  }
}

.surveys-wrapper {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  @include breakpoint($tablet) {
    max-width: 600px;
  }
}
.survey-item {
  margin-bottom: 0.5em;
  border-radius: 5px;
  border: 1px solid $gray-light;
  padding: 0.5em;
  background: white;
  transition: background-color 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  text-align: left;
  p {
    color: $text-main;
  }
  @include breakpoint($tablet) {
    margin-bottom: 0.3em;
    &:hover {
      background: rgba($gray-medium, 0.3);
    }
  }
  .item-wrapper {
    display: flex;
    flex-direction: row;    
  }
  .image {
    display: block;
    width: 40%;
    height: 0;
    padding-bottom: 40%;
    margin-right: 0.5em;
    background-size: cover;
    @include breakpoint($tablet) {
      width: 20%;
      padding-bottom: 20%;
    }
  }
  .text {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: left;
    font-size: 0.9em;
    width: 100%;
    p {
      margin-bottom: 0;
      width: 100%;
    }
    h2 {
      width: 100%;      
    }
    @include breakpoint($tablet) {
      font-size: 0.8em;
    }
  }
}
</style>
